import React, {Component} from "react";
import PropTypes from "prop-types";
import withProvider from "./packages_provider";
import FilteredList from "./filtered_list";
import queryString from "query-string";
import history from "./history";

class PackagesExplorer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			query: "",
			page: 1,
			withUnfree: false,
			channel: null,
		};
	}

	componentWillMount() {
		this.listener = history.listen((location) => this.updateFromURL(location));
		this.updateFromURL(history.location);
	}

	componentDidUpdate(prevProps, prevState) {
		const {query, page, withUnfree, channel} = this.state;
		const state = {query, page, withUnfree, channel};
		// "Compacts" query string.
		Object.keys(state).forEach((k) => {
			if (!state[k] || state[k].length === 0) {
				delete state[k];
			}
		})
		if (state["page"] === 1) {
			delete state["page"];
		}
		const search = queryString.stringify(state);
		history.replace({search});

		// Channel is handled one level *higher*, compared with the other
		// state variables. This is why we need to sync them here for URL support.
		if (prevProps["channel"] !== this.props["channel"]) {
			const {channel} = this.props;
			this.setState({channel});
		}
		if (prevState["channel"] !== this.state["channel"]) {
			const {channel} = this.state;
			this.props.onChannelChange(channel);
		}
	}

	componentWillUnmount() {
		// Stops listening.
		this.listener();
	}

	handleChange(e) {
		const {value} = e.target;
		this.setState({query: value});
	}

	handleChannelChange(e) {
		const {target: {value}} = e;
		this.setState({channel: value});
	}

	handleUnfree(e) {
		const {checked} = e.target;
		this.setState({withUnfree: checked});
	}

	handlePageChange(page) {
		this.setState({page});
	}

	updateFromURL(location) {
		const search = queryString.parse(location.search);

		// Defaults to empty string to work around infinite loop.
		let {query, page, withUnfree, channel} = search;
		if (!query) { query = ""; }

		if (this.state.query !== query) {
			this.setState({query});
		}
		page = parseInt(page, 10);
		if (page && this.state.page !== page) {
			this.setState({page});
		}
		withUnfree = !!withUnfree;
		if (this.state.withUnfree !== withUnfree) {
			this.setState({withUnfree});
		}
		if (channel && this.state.channel !== channel) {
			this.setState({channel});
			this.props.onChannelChange(channel);
		}
	}

	render() {
		const {data} = this.context;
		const {channels} = this.props;
		if (!data || !channels) { return (<div>Loading...</div>); }

		const {commit} = data;
		const {query, page, withUnfree, channel} = this.state;

		return (
			<div>
				<div>
					<div>
						<select
							className="channels-select span3"
							value={channel}
							onChange={(e) => this.handleChannelChange(e)}
						>
							{channels.map((channel, key) => <option key={key} value={channel}>{channel}</option>)}
						</select>
					</div>
					<div>
						<input
							type="text"
							className="search-query span3"
							placeholder="Search by name or description (regex allowed)"
							id="search"
							autoFocus="autofocus"
							value={query}
							onChange={(e) => this.handleChange(e)}
						/>
					</div>
					<div className="form-checkbox">
						<label>
							<input
								type="checkbox"
								checked={withUnfree}
								onChange={(e) => this.handleUnfree(e)}
							/>
							<span>Show unfree packages</span>
						</label>
					</div>
				</div>

				<hr />
				<FilteredList
					commit={commit} search={query}
					onPageChange={(page) => this.handlePageChange(page)}
					page={page}
					withUnfree={withUnfree}
				/>

				<p>
					<em><tt>&lt;nixpkgs&gt;</tt> commit {commit}</em>
				</p>
			</div>
		);
	}
}

PackagesExplorer.contextTypes = {
	data: PropTypes.object,
}

PackagesExplorer.propTypes = {
	channel: PropTypes.string,
	channels: PropTypes.array,
	onChannelChange: PropTypes.func,
};

export default withProvider(PackagesExplorer);



// WEBPACK FOOTER //
// ./src/packages_explorer.js